export default __webpack_public_path__ + "static/media/coach_guideme_lancingkit_lancets100_strips150_scale_cuff_gray@1x.fe3e6af1.webp";